import React, { useEffect } from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const FormCategory: React.FC<any> = () => {

    const config: MasterConfigs = {
        api: () => `/form-category`,
        modalTitle: (action: string) => `${action} Category`,
        isActionTab: true,
        getColumns: () => {
            return [
                {
                    title: "Catergory Name",
                    dataIndex: "name",
                    key: "name",
                },
                {
                    title: "Description",
                    dataIndex: "description",
                    key: "description",
                },
            ]
        },
        getFormColumns: () => {
            return [
                {
                    name: "name",
                    label: "Category Name",
                    type: "text",
                    rules: [{ required: true, message: "Please enter category name" }],
                },
                {
                    span: 16,
                },
                {
                    name: "description",
                    label: "Description",
                    type: "textarea",
                },
            ]
        },
        actions: [
            {
                name: "Add",
                actionType: "Add",
                settings: {
                    type: "primary"
                }
            }
        ]
    }

    return <MasterComponent config={config} />
}

export default FormCategory;